import { YhBox } from "@/components/YhBox";
import { BilledDataTable } from "./BilledDataTable";

export const BilledDataBox = () => {

    return (
        <>
            <YhBox>
                <BilledDataTable />
            </YhBox>
        </>
    )
}
